// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__VK1At","left":"Form_left__v6e9v","center":"Form_center__Ah9N2"};